"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForMs = waitForMs;
exports.shallowClone = shallowClone;
// pause execution for a given number of milliseconds
async function waitForMs(ms) {
    await new Promise((resolve) => setTimeout(resolve, ms));
}
function shallowClone(original) {
    return Object.assign(Object.create(Object.getPrototypeOf(original)), original);
}
//# sourceMappingURL=util.js.map